<template>
  <div class="AiDate">
    <client-only>
      <ai-typo class="AiDate-day" as="p" variant="featured">
        {{ formatDate(eventDate, 'dd') }}
      </ai-typo>
      <ai-typo as="p" variant="overline-01">
        {{ formatDate(eventDate, 'MMM yyy') }}
      </ai-typo>
    </client-only>
  </div>
</template>

<script setup lang="ts">
import { formatDate, extractDateFromApiString } from '~/helpers/date.helper';

import AiTypo from '../AiTypo/AiTypo.vue';

export interface AiDate {
  date?: string;
}

const eventDate = computed<Date>(() => extractDateFromApiString(props.date));

const props = withDefaults(defineProps<AiDate>(), {
  date: '',
});
</script>
<style lang="scss">
@use '@/assets/styles/utilities/colors';
@use '@/assets/styles/utilities/constants';

.AiDate {
  display: flex;
  flex-direction: column;
  p {
    color: colors.$gold-900;
    text-transform: uppercase;
  }
}

.AiDate-day {
  margin-bottom: constants.$margin-00;
}
</style>
